import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './SuccessPage.css';

const logoUrl = 'https://pay.shiroormatha.org/logo.png';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const receiptNumber = searchParams.get('receipt');
  const paymentId = searchParams.get('payment_id');
  const sevaName = searchParams.get('seva_name') || 'Selected Seva';
  const remarks = searchParams.get('remarks');

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="page-logo-wrapper">
          <img src={logoUrl} alt="Shiroor Matha" className="page-logo" />
        </div>
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#22c55e"/>
            <path d="m9 12 2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1>Payment Successful!</h1>
        <p className="success-message">
          Your seva booking has been confirmed successfully.
        </p>
        
        <div className="payment-details">
          <div className="detail-item">
            <span className="label">Seva Name:</span>
            <span className="value success-status">{sevaName}</span>
          </div>
          <div className="detail-item">
            <span className="label">Receipt Number:</span>
            <span className="value">{receiptNumber}</span>
          </div>
          <div className="detail-item">
            <span className="label">Payment ID:</span>
            <span className="value">{paymentId}</span>
          </div>
          {remarks && (
            <div className="detail-item">
              <span className="label">Prasada Collection:</span>
              <span className="value">{remarks}</span>
            </div>
          )}
          <div className="detail-item">
            <span className="label">Status:</span>
            <span className="value success-status">Confirmed</span>
          </div>
        </div>
        
        <div className="actions">
          <button 
            className="print-button"
            onClick={() => window.print()}
          >
            Print Receipt
          </button>
          <Link to="/" className="home-button">
            Book Another Seva
          </Link>
        </div>
        
        <div className="note">
          <p>
            <strong>Note:</strong> Please save this receipt for your records. 
            You may also receive an SMS/WhatsApp confirmation shortly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
